import React, {useState,useEffect,useRef} from 'react'
import searchicon from '../../../_metronic/images/hd_search.svg'
import _ from 'lodash';

export default function SearchComponent({handleSearch,placeholder}:any) {
  const [input, setInput] = useState<any>('');
  const inputRef = useRef<any>();

  useEffect(() => {
    // initialize debounce function to search once user has stopped typing every half second
    inputRef.current = _.debounce(onSearchText, 500);
  }, []);

  const onSearchText = (objInput:any) => {
    handleSearch(objInput);
  };

  const handleInputChange = (event:any) => {
    const tempInput = event.target.value;
    setInput(tempInput);
    inputRef.current(tempInput);
  };
  
  return (
    <>
      <input
        type='text'
        data-kt-ecommerce-order-filter='search'
        className='form-control form-control-solid w-250px pe-14'
        placeholder={placeholder}
        onChange={(e) => handleInputChange(e)}
        value={input}
      />
      <span className='svg-icon svg-icon-1 position-absolute me-4' style={{right: 0}}>
        <img src={searchicon} alt='search' />
      </span>
    </>
  )
}
